import React from "react";
import Dialog from "../../../../../../common/element/Dialog";

const ViewAssignment = ({
  dialogOpen,
  onDialogClose,
  sessionData,
  questionsData = []
}) => {
  console.log("Session Data in ViewAssignment:", sessionData);

  // Use questions from sessionData if available, otherwise fallback to questionsData
  const questionsList = sessionData?.questions || questionsData || [];

  return (
    <Dialog isOpen={dialogOpen} onClose={onDialogClose} width={650}>
      {/* Header */}
      <div className="flex border-b border-gray-100 px-6 py-4 items-center justify-between">
        <div className="flex items-center gap-3">
          {/* Document Icon */}
          <span className="h-9 w-9 border rounded-md border-gray-200 flex items-center justify-center text-gray-500 shadow-sm">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="9" y1="9" x2="15" y2="9"></line>
              <line x1="9" y1="13" x2="15" y2="13"></line>
              <line x1="9" y1="17" x2="12" y2="17"></line>
            </svg>
          </span>
          <h5 className="font-sans font-semibold text-[16px] text-[#111827]">
            View Assignment
          </h5>
        </div>
        
        {/* Close Icon */}
        <button
          onClick={onDialogClose}
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      {/* Body */}
      <div className="px-3 py-5 overflow-y-auto" style={{ maxHeight: "calc(90vh - 140px)" }}>
        {/* Assignment Topic Title */}
          <h4 className="font-semibold text-[16px] text-[#111827] mb-5 bg-[#FFF4E5] p-4 rounded-md">
            {sessionData?.assignment_name || "React Basics and Components"}
          </h4>

        {/* Questions & Answers List */}
        <div className="flex flex-col gap-5">
          {questionsList.map((question, index) => {
            // Accommodate both old data structure and new data structure
            const qText = question.question_text || question.question;
            const ansText = question.submitted_answer?.answer_text
              || question.answers?.find(a => a.sub_question_index === null)?.answer_text;

            const subQuestions = question.sub_questions || [];

            return (
              <div key={question.question_id || `q${index}`} className="flex flex-col border-b border-gray-200 pb-5">
                {/* Question */}
                <p className="text-[14px] font-medium leading-relaxed text-[#374151]">
                  Q{index + 1}. {qText}
                </p>

                {/* Answer Box - ONLY SHOWS IF THERE IS AN ANSWER */}
                {ansText && (
                  <div className="mt-2 px-3 py-2.5 bg-[#F9FAFB] border border-gray-200 rounded-md">
                    <p className="text-[14px] text-gray-800 whitespace-pre-wrap">
                      {ansText}
                    </p>
                  </div>
                )}

                {/* Sub Questions */}
                {subQuestions.length > 0 && (
                  <div className="mt-3 flex flex-col gap-3 pl-4">
                    {subQuestions.map((subQ, subIndex) => {
                      const subAnsText = question.answers?.find(a => a.sub_question_index === subIndex)?.answer_text;
                      return (
                        <div key={subIndex} className="flex flex-col">
                          <p className="text-[13px] font-medium text-[#6B7280]">
                            {String.fromCharCode(97 + subIndex)}. {subQ}
                          </p>
                          {subAnsText && (
                            <div className="mt-1.5 px-3 py-2 bg-[#F9FAFB] border border-gray-200 rounded-md">
                              <p className="text-[13px] text-gray-800 whitespace-pre-wrap">
                                {subAnsText}
                              </p>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}

          {/* Fallback if no questions are passed */}
          {questionsList.length === 0 && (
             <p className="text-[14px] text-gray-500 text-center py-4">No questions available.</p>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="px-6 py-4 border-t border-gray-100 flex justify-end">
        <button
          onClick={onDialogClose}
          className="px-5 py-2 rounded-lg bg-white border border-gray-200 text-[#374151] text-[14px] font-medium hover:bg-gray-50 transition-colors shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-200 focus:ring-offset-1"
        >
          Close
        </button>
      </div>
    </Dialog>
  );
};

export default ViewAssignment;